import { apiWrapper } from "@/services/api";

export const refundBookGroup = async (id) => {
  try {
    const apiParams = { book_group_id: id };
    await apiWrapper("POST", `refund`, apiParams, false, null, "Migrated");
  } catch (err) {
    console.log("ERROR!! refundBookGroup()");
    throw err;
  }
};
